import {createPersister} from '@github-ui/react-query-persister'
import type {SendAnalyticsEventFunction} from '@github-ui/use-analytics'
import type {Project} from './project'
import type {ProjectPickerQueryData} from './api-get-search-projects'

function isProject(obj: unknown): obj is Project {
  if (typeof obj !== 'object' || obj === null) return false
  const item = obj as Record<string, unknown>
  return (
    typeof item.id === 'string' &&
    typeof item.title === 'string' &&
    typeof item.closed === 'boolean' &&
    typeof item.number === 'number' &&
    typeof item.url === 'string' &&
    typeof item.viewerCanUpdate === 'boolean' &&
    typeof item.hasReachedItemsLimit === 'boolean'
  )
}

export function isProjectPickerQueryData(obj: unknown): obj is ProjectPickerQueryData {
  if (typeof obj !== 'object' || obj === null) return false
  const data = obj as {
    repositoryId?: unknown
    repositoryProjects?: unknown
    recentRepositoryProjects?: unknown
    ownerProjects?: unknown
    recentOwnerProjects?: unknown
  }
  return (
    typeof data.repositoryId === 'string' &&
    Array.isArray(data.repositoryProjects) &&
    data.repositoryProjects.every(isProject) &&
    Array.isArray(data.recentRepositoryProjects) &&
    data.recentRepositoryProjects.every(isProject) &&
    Array.isArray(data.ownerProjects) &&
    data.ownerProjects.every(isProject) &&
    Array.isArray(data.recentOwnerProjects) &&
    data.recentOwnerProjects.every(isProject)
  )
}

const ProjectPickerQueryDataValidator = {
  Check: (value: unknown): value is ProjectPickerQueryData => isProjectPickerQueryData(value),
  Code: () => 'manual-validator',
  *Errors() {
    /* no-op */
  },
}

export function createProjectPersister(sendAnalyticsEvent: SendAnalyticsEventFunction) {
  return createPersister({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: ProjectPickerQueryDataValidator as any,
    sendAnalyticsEvent,
    enabled: true,
  })
}
